import { createSlice } from '@reduxjs/toolkit'

const engagementPromoSlice = createSlice({
  name: 'engagementPromo',
  initialState: {
    highCandidateEngagementProVisible: false,
    secondJobAttemptPremiumVisible: false,
    firstApplicantProVisible: false,
  },
  reducers: {
    showHighCandidateEngagementPro: (state) => {
      state.highCandidateEngagementProVisible = true
    },
    showSecondJobAttemptPremium: (state) => {
      state.secondJobAttemptPremiumVisible = true
    },
    showFirstApplicantPro: (state) => {
      state.firstApplicantProVisible = true
    },
  },
  extraReducers: (builder) => {
    //Clear data after user logout so the next session loads eligibility from the API
    builder.addCase('auth/LogOut', (state) => {
      state.highCandidateEngagementProVisible = false
      state.secondJobAttemptPremiumVisible = false
      state.firstApplicantProVisible = false
    })
  },
})

export const {
  showHighCandidateEngagementPro,
  showSecondJobAttemptPremium,
  showFirstApplicantPro,
} = engagementPromoSlice.actions
export const selectHighCandidateEngagementProVisible = (state) =>
  state.engagementPromo.highCandidateEngagementProVisible
export const selectSecondJobAttemptPremiumVisible = (state) =>
  state.engagementPromo.secondJobAttemptPremiumVisible
export const selectFirstApplicantProVisible = (state) =>
  state.engagementPromo.firstApplicantProVisible
export default engagementPromoSlice.reducer
